/**
 * Up to two letters for an avatar with no photo: "Ana María López" is "AL",
 * "ana@gmail.com" is "A".
 *
 * First and last word rather than the first two, because a second given name
 * says less about who someone is than their surname does.
 */
export function initials(name: string): string {
  const words = name
    .replace(/@.*$/, "")
    .split(/[\s._-]+/)
    .filter(Boolean);
  if (words.length === 0) return "?";
  const first = words[0]!.charAt(0);
  const last = words.length > 1 ? words[words.length - 1]!.charAt(0) : "";
  return (first + last).toUpperCase();
}
